export default __webpack_public_path__ + "images/movr_18b854.svg";